<template>
    <div
        v-if="isMguuRespondent"
        class="cabinet cabinet_respondent"
    >
        <app-preloader v-if="!loaded" />

        <template v-else>
            <div class="cabinet__breadcrumbs">
                <router-link
                    class="cabinet__breadcrumbs-link"
                    :to="{ name: 'AssessmentPlansTestsMGUU' }"
                >
                    Мои тесты
                </router-link>
                <span class="cabinet__breadcrumbs-separator" aria-hidden="true">
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.8649 8L5.12754 12.1675C4.94311 12.3731 4.96079 12.6889 5.16703 12.8728C5.37327 13.0567 5.68997 13.0391 5.8744 12.8334L9.85067 8.39959C10.0547 8.17205 10.0547 7.82795 9.85067 7.60041L5.8744 3.16656C5.68997 2.9609 5.37327 2.94327 5.16703 3.12718C4.96079 3.31109 4.94311 3.62689 5.12754 3.83254L8.8649 8Z"
                            fill="#12122C"
                        />
                    </svg>
                </span>
                <span class="cabinet__breadcrumbs-current">Личные данные</span>
            </div>

            <div
                v-if="notificationMessage"
                class="cabinet__notification"
                :class="`cabinet__notification_${notificationType}`"
            >
                <button
                    type="button"
                    class="cabinet__notification-close"
                    aria-label="Закрыть уведомление"
                    @click="notificationMessage = ''"
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.6281 7.27934C8.25565 6.90689 7.65179 6.90689 7.27934 7.27934C6.90689 7.65179 6.90689 8.25565 7.27934 8.6281L10.6512 12L7.27934 15.3719C6.90689 15.7444 6.90689 16.3482 7.27934 16.7207C7.65179 17.0931 8.25565 17.0931 8.6281 16.7207L12 13.3488L15.3719 16.7207C15.7444 17.0931 16.3482 17.0931 16.7207 16.7207C17.0931 16.3482 17.0931 15.7444 16.7207 15.3719L13.3488 12L16.7207 8.6281C17.0931 8.25565 17.0931 7.65179 16.7207 7.27934C16.3482 6.90689 15.7444 6.90689 15.3719 7.27934L12 10.6512L8.6281 7.27934Z"
                            fill="#12122C"
                        />
                    </svg>
                </button>
                <span
                    v-if="notificationType === 'success'"
                    class="cabinet__notification-icon"
                    aria-hidden="true"
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M9.29289 15.7071C9.68342 16.0976 10.3166 16.0976 10.7071 15.7071L17.7071 8.70711C18.0976 8.31658 18.0976 7.68342 17.7071 7.29289C17.3166 6.90237 16.6834 6.90237 16.2929 7.29289L10 13.5858L7.70711 11.2929C7.31658 10.9024 6.68342 10.9024 6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071L9.29289 15.7071Z"
                            fill="#6EC431"
                        />
                    </svg>
                </span>
                <span
                    v-else
                    class="cabinet__notification-icon cabinet__notification-icon_error"
                    aria-hidden="true"
                >
                    <info-icon />
                </span>
                <span>{{ notificationMessage }}</span>
            </div>

            <app-title>
                <template #title> Личные данные </template>
            </app-title>

            <alert
                v-if="!user.allFieldsAreFilled && !isAdmin"
                type="error"
                class="mb-4"
            >
                Доступ к приложению заблокирован. Пожалуйста, заполните все
                обязательные поля
            </alert>
            <alert
                v-else-if="typeof this.$route.query.plannofilled === 'string'"
                type="error"
                class="mb-4"
            >
                Доступ к плану заблокирован. Пожалуйста, заполните все обязательные
                поля
            </alert>

            <user-form-builder
                :user="user"
                :handler="save"
                :half="true"
                handler-button-text="Сохранить"
                @validation-error="
                    notificationType = 'error';
                    notificationMessage = $event;
                "
            />
        </template>
    </div>

    <loader-wrapper
        v-else
        :loading="!loaded"
        class="cabinet"
    >
        <div v-if="isMguuRespondent" class="cabinet__breadcrumbs">
            <router-link
                class="cabinet__breadcrumbs-link"
                :to="{ name: 'AssessmentPlansTestsMGUU' }"
            >
                Мои тесты
            </router-link>
            <span class="cabinet__breadcrumbs-separator" aria-hidden="true">
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.8649 8L5.12754 12.1675C4.94311 12.3731 4.96079 12.6889 5.16703 12.8728C5.37327 13.0567 5.68997 13.0391 5.8744 12.8334L9.85067 8.39959C10.0547 8.17205 10.0547 7.82795 9.85067 7.60041L5.8744 3.16656C5.68997 2.9609 5.37327 2.94327 5.16703 3.12718C4.96079 3.31109 4.94311 3.62689 5.12754 3.83254L8.8649 8Z"
                        fill="#12122C"
                    />
                </svg>
            </span>
            <span class="cabinet__breadcrumbs-current">Личные данные</span>
        </div>

        <div
            v-if="isMguuRespondent && notificationMessage"
            class="cabinet__notification"
            :class="`cabinet__notification_${notificationType}`"
        >
            <button
                type="button"
                class="cabinet__notification-close"
                aria-label="Закрыть уведомление"
                @click="notificationMessage = ''"
            >
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.6281 7.27934C8.25565 6.90689 7.65179 6.90689 7.27934 7.27934C6.90689 7.65179 6.90689 8.25565 7.27934 8.6281L10.6512 12L7.27934 15.3719C6.90689 15.7444 6.90689 16.3482 7.27934 16.7207C7.65179 17.0931 8.25565 17.0931 8.6281 16.7207L12 13.3488L15.3719 16.7207C15.7444 17.0931 16.3482 17.0931 16.7207 16.7207C17.0931 16.3482 17.0931 15.7444 16.7207 15.3719L13.3488 12L16.7207 8.6281C17.0931 8.25565 17.0931 7.65179 16.7207 7.27934C16.3482 6.90689 15.7444 6.90689 15.3719 7.27934L12 10.6512L8.6281 7.27934Z"
                        fill="#12122C"
                    />
                </svg>
            </button>
            <span
                v-if="notificationType === 'success'"
                class="cabinet__notification-icon"
                aria-hidden="true"
            >
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.29289 15.7071C9.68342 16.0976 10.3166 16.0976 10.7071 15.7071L17.7071 8.70711C18.0976 8.31658 18.0976 7.68342 17.7071 7.29289C17.3166 6.90237 16.6834 6.90237 16.2929 7.29289L10 13.5858L7.70711 11.2929C7.31658 10.9024 6.68342 10.9024 6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071L9.29289 15.7071Z"
                        fill="#6EC431"
                    />
                </svg>
            </span>
            <span
                v-else
                class="cabinet__notification-icon cabinet__notification-icon_error"
                aria-hidden="true"
            >
                <info-icon />
            </span>
            <span>{{ notificationMessage }}</span>
        </div>

        <app-title v-if="isMguuRespondent">
            <template #title> Личные данные </template>
        </app-title>

        <alert
            v-if="!user.allFieldsAreFilled && !isAdmin"
            type="error"
            class="mb-4"
        >
            Доступ к приложению заблокирован. Пожалуйста, заполните все
            обязательные поля
        </alert>
        <alert
            v-else-if="typeof this.$route.query.plannofilled === 'string'"
            type="error"
            class="mb-4"
        >
            Доступ к плану заблокирован. Пожалуйста, заполните все обязательные
            поля
        </alert>

        <user-form-builder
            :user="user"
            :handler="save"
            :half="true"
            handler-button-text="Сохранить"
        />
    </loader-wrapper>
</template>

<script>
import MtInput from '@/components/UI/mtInput/mtInput.vue';
import AuthApi from '@/api/auth.api.ts';
import mtButton from '@/components/UI/mtButton/index.vue';
import validation from '@/plugins/validation';
import Alert from '@/components/UI/AppAlert/AppAlert.vue';
import genders from '@/constants/genders';
import AppInput from '@/components/UI/AppInput/AppInput.vue';
import MtRadioGroup from '@/components/UI/mtRadio/mtRadioGroup.vue';
import MtRadio from '@/components/UI/mtRadio/mtRadio.vue';
import AppSelect from '@/components/UI/AppSelect/AppSelect.vue';
import DynamicFormBuilder from '@/components/workspace/DynamicFormBuilder.vue';
import AppDateTimePicker from '@/components/UI/AppDateTimePicker/AppDateTimePicker.vue';
import AppDatePicker from '@/components/UI/AppDateTimePicker/AppDateTimePicker.vue';
import MtLinearProgress from '@/components/UI/mtLinearProgress/mtLinearProgress.vue';
import { mapGetters, mapState } from 'vuex';
import AppFormBuilder from '@/components/UI/AppFormBuilder.vue';
import AppInputAmount from '@/components/UI/AppInputAmount/AppInputAmount.vue';
import mtRadioGroup from '@/components/UI/mtRadio/mtRadioGroup.vue';
import { required, requiredIf } from '@vuelidate/validators';
import UserFormBuilder from '@/components/workspace/UserFormBuilder.vue';
import { mapActions } from 'vuex';
import LoaderWrapper from '@/components/UI/LoaderWrapper.vue';
import AppPreloader from '@/components/workspace/AppPreloader.vue';
import AppTitle from '@/components/layouts/AppTitle/AppTitle.vue';
import InfoIcon from '@/components/icons/InfoIcon.vue';
export default {
    name: 'Cabinet',
    components: {
        InfoIcon,
        AppTitle,
        AppPreloader,
        LoaderWrapper,
        UserFormBuilder,
        AppFormBuilder,
        MtLinearProgress,
        AppDatePicker,
        AppDateTimePicker,
        DynamicFormBuilder,
        AppSelect,
        MtRadio,
        MtRadioGroup,
        AppInput,
        Alert,
        mtButton,
        MtInput,
    },
    data() {
        return {
            user: null,
            loaded: false,
            notificationMessage: '',
            notificationType: 'success',

            genders,
        };
    },
    computed: {
        ...mapGetters(['authUser', 'isAdmin']),
        isMguuRespondent() {
            return (
                this.authUser?.role?.slug === 'respondent' &&
                this.app_design_type === 'mguu'
            );
        },
    },
    methods: {
        ...mapActions(['getAuthUser']),
        async getUserInfo() {
            const { data } = await AuthApi.getUserInfo();
            this.user = data.data;
        },

        async save(payload) {
            this.notificationMessage = '';

            return await AuthApi.updateUserInfo(payload)
                .then((response) => {
                    if (this.isMguuRespondent) {
                        this.getAuthUser();
                        this.notificationType = 'success';
                        this.notificationMessage =
                            'Ваши личные данные успешно обновлены';
                        return;
                    }

                    this.$router.push({ name: 'AssessmentPlansList' });
                    this.getAuthUser();

                    this.$toast.success('Ваши личные данные успешно обновлены');
                })
                .catch((error) => {
                    if (this.isMguuRespondent) {
                        this.notificationType = 'error';
                        this.notificationMessage =
                            'Непредвиденная ошибка на сервере, пожалуйста повторите позже';
                        return;
                    }

                    this.$toast.error(
                        'Непредвиденная ошибка на сервере, пожалуйста повторите позже',
                    );
                });
        },
    },
    async mounted() {
        await this.getUserInfo();
        this.loaded = true;
    },
};
</script>

<style lang="scss">
.cabinet {
    border: 1px solid #dfe0eb;
    padding: 32px;
    border-radius: 8px;
    max-width: 700px;
    .mt-button {
        width: 100%;
    }

    &_respondent {
        border: none;
        padding: 0;
        margin: 0 auto;
        width: 100%;
        max-width: 876px;

        .cabinet__breadcrumbs {
            display: flex;
            align-items: center;
            gap: 8px;
            margin: -24px 0 24px 0;
            color: #8e8e9d;
            font-weight: 500;
            font-size: 16px;
            line-height: 16px;
        }

        @media (max-width: 768px) {
            .cabinet__breadcrumbs {
                margin: 0 0 24px 0;
            }
        }

        .cabinet__breadcrumbs-link {
            color: #8e8e9d;
            text-decoration: none;

            &:hover {
                color: #222a76;
            }
        }

        .cabinet__breadcrumbs-separator {
            width: 16px;
            height: 16px;
            margin: 0 2px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
        }

        .cabinet__breadcrumbs-current {
            color: #12122c;
        }

        .cabinet__notification {
            position: relative;
            display: flex;
            align-items: center;
            gap: 12px;
            border-radius: 16px;
            padding: 24px 72px 24px 24px;
            margin-bottom: 12px;
            color: #12122c;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
        }

        .cabinet__notification-close {
            position: absolute;
            top: 0;
            right: 0;
            width: 40px;
            height: 40px;
            border: none;
            background: transparent;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            cursor: pointer;
            color: inherit;
        }

        .cabinet__notification-icon {
            width: 24px;
            height: 24px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
        }

        .cabinet__notification-icon_error {
            color: rgba(255, 50, 14, 1);

            :deep(svg) {
                width: 24px;
                height: 24px;
                display: block;
            }
        }

        .cabinet__notification_success {
            background: #e2f3d6;
        }

        .cabinet__notification_error {
            background: #ffd6cf;
        }

        .app-title {
            background: #fff;
            border-radius: 32px;
            padding: 32px 36px;
            margin-bottom: 24px;
            border-bottom: none;
        }

        @media (max-width: 768px) {
            .app-title {
                padding: 20px;
                border-radius: 16px;
                margin-bottom: 16px;
            }
        }
    }
}
</style>
